import { useTranslate } from "@opensea/next-translate"
import { Security } from "@opensea/ui-kit/icons"
import React from "react"
import { MfaMethodsModal } from "@/features/wallet/components/MfaMethodsModal"
import { useGlobalModal } from "@/providers/GlobalModal"
import { SettingsItem } from "./SettingsItem.react"

export function MfaItem() {
  const t = useTranslate("settings")
  const { openModal, closeModal } = useGlobalModal()

  const handleClick = () => {
    openModal(<MfaMethodsModal onClose={closeModal} />)
  }

  return (
    <SettingsItem
      icon={<Security />}
      label={t("mfaEnrollmentItem.label", "Two-factor verification")}
      onClick={handleClick}
    />
  )
}
